import PitchDisplay from './PitchDisplay'

export default function PitchTab({
  fixture, lineup, subs, substitutedOff,
  multiSubMode, multiSubsOff, multiSubsOn,
  swapFirst, isUnlimitedSubs, isFriendly,
  isTracker, redCardedPlayers, blackCardPlayers,
  isRedCarded, isInSinBin, handlePlayerTap,
  logMultiSub, setMultiSubMode, setMultiSubsOff,
  setMultiSubsOn, setSwapFirst,
}) {
  if (!fixture) return null
  return (
    <div style={{ padding: '10px 12px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
        <p style={{ fontSize: '11px', color: '#888' }}>Tap player to log event</p>
        <div style={{ display: 'flex', gap: '6px' }}>
          {multiSubMode
            ? <button onClick={() => { setMultiSubMode(false); setMultiSubsOff([]); setMultiSubsOn([]) }} style={{ fontSize: '11px', padding: '3px 8px', borderRadius: '6px', border: '1px solid #A32D2D', background: '#FCEBEB', cursor: 'pointer', color: '#A32D2D' }}>✕ Cancel</button>
            : <button onClick={() => { setMultiSubMode(true); setSwapFirst(null) }} style={{ fontSize: '11px', padding: '3px 8px', borderRadius: '6px', border: '1px solid #533AB7', background: '#EEEDFE', cursor: 'pointer', color: '#533AB7' }}>⇄⇄ Multi-Sub</button>
          }
          {!multiSubMode && (swapFirst
            ? <button onClick={() => setSwapFirst(null)} style={{ fontSize: '11px', padding: '3px 8px', borderRadius: '6px', border: '1px solid #FFD700', background: '#FFF9E6', cursor: 'pointer', color: '#854F0B' }}>✕ Cancel Swap</button>
            : <button onClick={() => setSwapFirst('pending')} style={{ fontSize: '11px', padding: '3px 8px', borderRadius: '6px', border: '1px solid #ccc', background: 'white', cursor: 'pointer', color: '#533AB7' }}>⇄ Swap</button>
          )}
        </div>
      </div>

      {swapFirst && swapFirst !== 'pending' && (
        <div style={{ background: '#FFF9E6', border: '1px solid #FFD700', borderRadius: '8px', padding: '6px 10px', marginBottom: '6px', fontSize: '12px', color: '#854F0B' }}>
          Swapping <strong>{swapFirst.full_name}</strong> — tap another player to swap positions
        </div>
      )}

      {multiSubMode && (
        <div style={{ background: '#EEEDFE', border: '1px solid #533AB7', borderRadius: '8px', padding: '8px 10px', marginBottom: '6px' }}>
          <p style={{ fontSize: '12px', color: '#533AB7', marginBottom: '4px' }}>
            <strong>Multi-Sub:</strong> {multiSubsOff.length} coming off · {multiSubsOn.length} coming on
          </p>
          {multiSubsOff.length > 0 && <p style={{ fontSize: '11px', color: '#533AB7', marginBottom: '2px' }}>Off: {multiSubsOff.map(p => p.full_name.split(' ').slice(-1)[0]).join(', ')}</p>}
          {multiSubsOn.length > 0 && <p style={{ fontSize: '11px', color: '#3B6D11', marginBottom: '4px' }}>On: {multiSubsOn.map(p => p.full_name.split(' ').slice(-1)[0]).join(', ')}</p>}
          {multiSubsOff.length > 0 && multiSubsOn.length > 0 && multiSubsOff.length === multiSubsOn.length && isTracker && (
            <button onClick={logMultiSub} style={{ width: '100%', padding: '6px', background: '#533AB7', color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', marginTop: '2px' }}>
              ✓ Confirm {multiSubsOff.length} substitution{multiSubsOff.length > 1 ? 's' : ''}
            </button>
          )}
        </div>
      )}

      <PitchDisplay
        lineup={lineup}
        sport={fixture.sport}
        playersPerSide={fixture.players_per_side}
        onPlayerTap={(p) => handlePlayerTap(p, false)}
        swapFirst={swapFirst}
        redCardedPlayers={redCardedPlayers}
        blackCardPlayers={blackCardPlayers}
        multiSubsOff={multiSubsOff}
      />

      {subs.length > 0 && (
        <div style={{ marginTop: '10px' }}>
          <p style={{ fontSize: '10px', color: '#888', marginBottom: '5px' }}>Substitutes</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
            {subs.map(p => {
              const wasOff = substitutedOff.find(x => x.id === p.id)
              const isRed = isRedCarded(p.id)
              const isSin = isInSinBin(p.id)
              const avail = (isUnlimitedSubs || isFriendly || !wasOff) && !isRed
              const isMultiSubOn = multiSubsOn.some(x => x.id === p.id)
              return (
                <button key={p.id} onClick={() => avail && !isSin ? handlePlayerTap(p, true) : null}
                  style={{ padding: '5px 10px', borderRadius: '8px', border: '0.5px solid ' + (isMultiSubOn ? '#3B6D11' : isRed ? '#A32D2D' : isSin ? '#444' : '#e0e0e0'), background: isMultiSubOn ? '#EAF3DE' : isRed ? '#FCEBEB' : isSin ? '#2C2C2A' : '#f8f8f8', fontSize: '12px', cursor: avail && !isSin ? 'pointer' : 'default', display: 'flex', alignItems: 'center', gap: '5px', opacity: avail ? 1 : 0.5 }}>
                  <span style={{ width: '18px', height: '18px', borderRadius: '50%', background: isMultiSubOn ? '#3B6D11' : isRed ? '#A32D2D' : isSin ? '#555' : '#533AB7', color: 'white', fontSize: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '500' }}>
                    {p.jersey_number || p.assigned_number || '—'}
                  </span>
                  <span style={{ color: isMultiSubOn ? '#3B6D11' : isRed ? '#A32D2D' : isSin ? 'white' : 'inherit', fontSize: '12px' }}>{p.full_name}</span>
                </button>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}